import { render } from "./addEditQuestion.vue?vue&type=template&id=20e76e6a"
import script from "./addEditQuestion.vue?vue&type=script&lang=js"
export * from "./addEditQuestion.vue?vue&type=script&lang=js"

import "./addEditQuestion.vue?vue&type=style&index=0&id=20e76e6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__